// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"49caf131","269":"d99de889","1899":"ffda678a","5106":"101d25e6","9934":"f93c9a42"}[chunkId] + ".chunk.css";
};